/**
 * Searches the provided array for the provided element using the binary search
 * algorithm.
 * @param array Sorted array (in an order compatible with `compareFn`) in which
 * to find the provided element.
 * @param element Element to find in the array.
 * @param compareFn Comparison function.
 * @returns The index of the element if it is contained in the array; otherwise,
 * the inverted insertion point `-i - 1`.
 */
export function binarySearch<T>(
  array: T[],
  element: T,
  compareFn: (v1: T, v2: T) => number,
): number {
  let low = 0;
  let high = array.length - 1;
  while (low <= high) {
    const mid = (low + high) >>> 1;
    const cmp = compareFn(array[mid], element);
    if (cmp < 0) {
      low = mid + 1;
    } else if (cmp > 0) {
      high = mid - 1;
    } else {
      return mid;
    }
  }
  return -(low + 1);
}
